<template>
  <v-list-tile @click="expandLateralNav" class="white-icon">
    <v-list-tile-action>
      <v-tooltip right open-delay="50" close-delay="50">
        <v-icon slot="activator" color="#c4c9d0">{{ area.icono }}</v-icon>
        <span>{{ area.nombre }}</span>
      </v-tooltip>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    area: Object
  },

  methods: {
    expandLateralNav () {
      this.$store.commit('changeLateralNav')
    }
  }
}
</script>

<style scoped>
.white-icon i {
  color: #c4c9d0 !important;
}
</style>
